import React, {
  useCallback,
  useEffect,
  useState,
  useMemo,
  useRef,
} from "react";
import MUITable from "../../../../../../../common/components/mui-table/mui-table";
import _ from "lodash";
import { AlertComponent } from "../../../../../../../common/components";
import { Checkbox } from "@mui/material";
import LeadsStatus from "../../../../../../leads/leads-status"; // Custom badge component
import "../../../../../../leads/lead-list.scss";
import AddLeadFilter from "./add-lead-filter";
import LeadFilterOptions from "../../../../../../leads/lead-filter/lead-filter-options";
import { filterOptions } from "../../../../../../leads/lead-filter/lead-filter.constant";
import PaginationComponent from "../../../../../../../common/components/pagination-component/pagination-component";
import { getLeads } from "../../../../../../../api/lead";
import { useLogin } from "../../../../../../../common/hooks/useUser";
import { useSetLoading } from "../../../../../../../common/hooks/appearance";
import { useLocation } from "react-router-dom";
import { routes } from "../../../../../../../constants/routes";
import StatusDialog from "../status-dialog/update-status-dialog";
import { campainAssignToLeads } from "../../../../../../../api/lead";
import AddLead from "./add-lead";
import { AlertType } from "../../../../../../../utils/util-types";
interface SortOption {
  sortDirection: string | null;
  sortBy: string | null;
}
interface AddLeadListProps {
  allCampaignData: any;
  setAlertMessage: (msg: string) => void;
  setAlertType: (type: AlertType) => void;
  setAlertOpen: (open: boolean) => void;
  handleCloseModal: () => void;
  campaignName: any;
}
const AddLeadList: React.FC<AddLeadListProps> = ({
  allCampaignData,
  setAlertMessage,
  setAlertType,
  setAlertOpen,
  handleCloseModal,
  campaignName
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedLeads, setSelectedLeads] = useState<number[]>([]);
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const [selectedLeadsFilter, setSelectedLeadsFilters] = useState<number[]>([]);
  const [selectedAllLeads, setSelectedAllLeads] = useState<any>(null);
  const [selectedCreateLeads, setSelectedCreateLeads] = useState<any>(null);
  const [selectedActions, setSelectedActions] = useState<any>(null);
  const [totalRecords, setTotalRecords] = useState<number>(0); // Set an initial value for testing
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize] = useState<number>(15);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [viewOpen, setViewOpen] = useState<boolean>(false);
  const [sortOption, setSortOption] = useState<SortOption>({
    sortDirection: null,
    sortBy: null,
  });
  const [isShowCreateLead, setIsShowCreateLead] = useState<boolean>(false);
  const [isShowCreateLeadSection, setIsShowCreateLeadSection] =
    useState<boolean>(false);
  const [activeFilters, setActiveFilters] = useState<any>({});
  const [searchText, setSearchText] = useState<string>("");
  const [isResetSearch, setIsResetSearch] = useState(false);
  const searchRef = useRef<{ clear: () => void }>(null);
  const [disableMassActions, setDisableMassActions] = useState<boolean>(true);
  const [selectOpen, setSelectOpen] = useState(false);
  const isSearchTriggered = useRef(false);
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [statusFilter, setStatusFilter] = useState<string>("Planned");
  const [newLeadId, setNewLeadId] = useState<number | null>(null);
  const { tenantDetails } = useLogin();
  const filteredLeadFilterOptions = useMemo(() => {
  if (tenantDetails?.tenantType === "Tenant") {
    return filterOptions.filter(opt => opt.labels !== "Assigned Partner");
  }
  return filterOptions;
}, [tenantDetails,filterOptions]);
const [selectedLeadsFilterOptions, setSelectedLeadsFilterOptions] =
    useState<any[]>(filteredLeadFilterOptions);

  const handleSearch = useCallback(
    _.debounce((text: string) => {
      setSearchText(text);
      isSearchTriggered.current = true;
      setCurrentPage(1);
      if (text === "") {
        setIsResetSearch(true);
        setTimeout(() => setIsResetSearch(false), 100);
      }
    }, 500),
    []
  );

  const resetSearch = () => {
    setSearchText("");
    if (searchRef.current) {
      searchRef.current.clear();
    }
    handleSearch("");
  };

  const userDetails = useLogin();
  const leadOwner =
    userDetails?.userDetails?.firstName +
    " " +
    userDetails?.userDetails?.lastName;

  const fetchLeads = async (
    page = 1,
    search: string = "",
    filters: any = {}
  ) => {
    setLoading(true);
    try {
      const offset = (page - 1) * pageSize;
      let params: any = {
        limit: pageSize,
        offset: offset,
        leadsList: true
      };
      if (sortOption?.sortBy) {
        params = { ...params, ...sortOption };
      }
      if (search) {
        params.searchText = search;
      }
      if (filters?.annualRevenue?.min) {
        params.leadValueMin = filters.annualRevenue.min;
      }
      if (filters?.annualRevenue?.max) {
        params.leadValueMax = filters.annualRevenue.max;
      }
      if (filters?.email) {
        params.email = filters.email;
      }
      if (filters?.city) {
        params.city = filters.city;
      }
      if (filters?.country) {
        params.country = filters.country;
      }
      if (filters?.fax) {
        params.fax = filters.fax;
      }
      if (filters?.firstName) {
        params.firstName = filters.firstName;
      }
      if (filters?.lastName) {
        params.lastName = filters.lastName;
      }
      if (filters?.company) {
        params.company = filters.company;
      }
      if (filters?.industry) {
        params.industry = filters.industry;
      }
      if (filters?.confidenceScore) {
        params.confidenceScore = filters.confidenceScore;
      }
      if (filters?.leadStatus) {
        params.leadStatus = filters.leadStatus;
      }
      if (filters?.createdTimeStart && filters.createdTimeEnd) {
        // if (filters.createdTimeStart.isSame(filters.createdTimeEnd)) {
          params.createdTimeStart = filters.createdTimeStart.startOf("day");
          params.createdTimeEnd = filters.createdTimeEnd.endOf("day");
        // } else {
        //   params.createdTimeStart = filters.createdTimeStart;
        //   params.createdTimeEnd = filters.createdTimeEnd;
        // }
      }
      if (filters?.lastActivityTimeStart && filters.lastActivityTimeEnd) {
        // if (filters.lastActivityTimeStart.isSame(filters.lastActivityTimeEnd)) {
          params.lastActivityStart =
            filters.lastActivityTimeStart.startOf("day");
          params.lastActivityEnd = filters.lastActivityTimeEnd.endOf("day");
        // } else {
        //   params.lastActivityStart = filters.lastActivityTimeStart;
        //   params.lastActivityEnd = filters.lastActivityTimeEnd;
        // }
      }
      if (filters?.createdByUserIds?.length > 0) {
        params.createdBy = filters.createdByUserIds.map(Number);
      }
      if (filters?.leadOwnerIds?.length > 0) {
        params.leadOwner = filters.leadOwnerIds.map(Number);
      }
      if (filters?.assignedPartnerIds?.length > 0) {
        params.assignedPartner = filters.assignedPartnerIds.map(Number);
      }
      const response = await getLeads(params, "Lead Details");
      setData(response.data.data.leads);
      setTotalRecords(response.data.data.totalRecords);
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message || "Failed to fetch campaigns"
      );
      setAlertType("error");
      setAlertOpen(true);
      setError("Failed to fetch leads list");
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!viewOpen) {
      const pageToUse = isSearchTriggered.current ? 1 : currentPage;
      fetchLeads(pageToUse, searchText, activeFilters);
      isSearchTriggered.current = false;
    }
  }, [currentPage, searchText, isOpen, sortOption, viewOpen, activeFilters]);
  useEffect(() => {
  if (newLeadId && data.length) {
    const exists = data.some((lead) => lead.id === newLeadId);
    if (exists) {
      setSelectedLeadsMap((prev) => {
        const currentSelected = prev[currentPage] || [];
        return {
          ...prev,
          [currentPage]: Array.from(new Set([...currentSelected, newLeadId])),
        };
      });
      setNewLeadId(null); // Clear state after using
    }
  }
}, [data, newLeadId, currentPage]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value);
  };
  const [selectedLeadsMap, setSelectedLeadsMap] = useState<{
    [page: number]: number[];
  }>({});
  const isAllSelected = selectedLeadsMap[currentPage]?.length === data.length;
  const isIndeterminate =
    selectedLeadsMap[currentPage]?.length > 0 &&
    selectedLeadsMap[currentPage]?.length < data.length;
  const handleSelectAll = () => {
    setSelectedLeadsMap((prev) => {
      const currentPageLeads = data.map((item) => item.id);
      const selectedLeadsOnPage = prev[currentPage] || [];

      if (selectedLeadsOnPage.length > 0) {
        return { ...prev, [currentPage]: [] };
      }
      return { ...prev, [currentPage]: currentPageLeads };
    });
  };

  const handleCheckboxChange = (id: number) => {
    setSelectedLeadsMap((prev) => {
      const prevSelected = prev[currentPage] || [];
      const newSelected = prevSelected.includes(id)
        ? prevSelected.filter((leadId) => leadId !== id)
        : [...prevSelected, id];

      return {
        ...prev,
        [currentPage]: newSelected,
      };
    });
  };

  const headers = [
    {
      key: "select",
      label: (
        <Checkbox
          checked={isAllSelected}
          indeterminate={isIndeterminate}
          onChange={handleSelectAll}
        />
      ),
    },
    { key: "leadName", label: "Lead Name", isSortable: true },
    { key: "email", label: "Email", isSortable: true },
    { key: "phone", label: "Phone Number", isSortable: true },
    { key: "leadSource", label: "Lead Source", isSortable: true },
    { key: "leadOwner", label: "Lead Owner", isSortable: true },
    { key: "leadCreatedBy", label: "Created By", isSortable: true },
    { key: "leadStatus", label: "Lead Status", isSortable: true },
  ];

  const mapColumnNameToField = (columnName: string): string => {
    const mapping: Record<string, string> = {
      leadName: "first_name",
      email: "primary_email_address",
      phone: "primary_phone_number",
      leadSource: "lead_source",
      leadOwner: "lead_owner",
      leadStatus: "lead_status",
      leadCreatedBy: "created_by",
    };

    return mapping[columnName] || columnName;
  };
  const handleSort = (column: string, sortType: string) => {
    let sortValues: SortOption = { sortBy: null, sortDirection: null };
    if (sortType !== "Unsort") {
      const mappedField = mapColumnNameToField(column);
      sortValues = { sortBy: mappedField, sortDirection: sortType };
    }
    setCurrentPage(1);
    setSortOption(sortValues);
  };

  const fetchFullName = (item: any) => {
    const firstName = item?.first_name?.trim();
    const lastName = item?.last_name?.trim();
    const middleName = item?.middle_name ? item?.middle_name?.trim() : "";

    const fullName =
      firstName && lastName
        ? `${firstName} ${middleName} ${lastName}`
        : firstName
          ? firstName
          : middleName
            ? middleName
            : lastName
              ? lastName
              : "-";
    return fullName;
  };

  const formattedData = useMemo(() => {
    if (Array.isArray(data)) {
      return data.map((item) => {
        const firstName = item.first_name?.trim();
        const lastName = item.last_name?.trim();
        const middleName = item?.middle_name ? item?.middle_name?.trim() : "";
        const fullName =
          firstName && lastName
            ? `${firstName ? `${firstName} ` : ""}${middleName ? `${middleName} ` : ""}${lastName}`
            : firstName || middleName || lastName || "-";

        const leadName = fullName;
        const leadOwnerName = fetchFullName(item?.owner);
        const createdBy = fetchFullName(item?.createdBy);
        return {
          id: item.id,
          leadName: leadName,
          email: item.primary_email_address || "-",
          phone: item.primary_phone_number || "-",
          leadSource: item.lead_source || "-",
          leadOwner: leadOwnerName,
          leadStatus: item.lead_status || "-",
          leadCreatedBy: createdBy,
        };
      });
    }
    return [];
  }, [data, leadOwner]);

  const checkDisableOfActionScope = () => {
    const disableScope = [{ "All Leads": true }, { "Selected Leads": true }];
    if (data?.length >= 1) disableScope[0]["All Leads"] = false;
    if (Object.values(selectedLeadsMap)?.flat(Infinity).length >= 1)
      disableScope[1]["Selected Leads"] = false;
    return disableScope;
  };

  useEffect(() => {
    if (Object.values(selectedLeadsMap)?.flat(Infinity).length >= 1) {
      setDisableMassActions(false);
    } else if (Object.values(selectedLeadsMap)?.flat(Infinity).length === 0) {
      setDisableMassActions(true);
    }
  }, [selectedLeadsMap]);

  const appliedFilterCount = useMemo(() => {
    let count = 0;
    const dateFilterActive =
      activeFilters.createdTimeStart || activeFilters.createdTimeEnd;
    const runFilterActive =
      activeFilters.lastActivityTimeStart || activeFilters.lastActivityTimeEnd;

    const otherFilters = { ...activeFilters };
    delete otherFilters.createdTimeStart;
    delete otherFilters.createdTimeEnd;
    delete otherFilters.lastActivityTimeStart;
    delete otherFilters.lastActivityTimeEnd;


    const otherActiveFilters = Object.values(otherFilters).filter((val) => {
      if (val === undefined || val === "" || val === null) return false;
      if (Array.isArray(val)) return val.length > 0;
      if (typeof val === "object") {
        return Object.values(val).some(
          (v) => v !== "" && v !== undefined && v !== null
        );
      }
      return true;
    }).length;
    if (dateFilterActive) {
      count += 1;
    }
    if (runFilterActive) {
      count += 1;
    }

    count += otherActiveFilters;

    return count;
  }, [activeFilters]);
  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);
  const [showImportModal, setShowImportModal] = useState(false);

  const noResultText = useMemo(() => {
    if (loading) {
      return "Loading Leads...";
    }
    if (searchText) {
      return "No leads  found matching your search criteria";
    }
    return "No leads found";
  }, [loading, searchText]);
  const handleAssignLeads = async () => {
  const leadIds = Object.values(selectedLeadsMap).flat();
  const campaignId = allCampaignData;

  try {
    await campainAssignToLeads(
      {
        actionScope: "multiLead_singleCampaign",
        leadIds,
        campaignId,
        leadStatusInCampaign: statusFilter,
      },
      "Lead Details"
    );

    setOpenStatusDialog(false);
    handleCloseModal(); // close modal on success
    setAlertMessage(
        leadIds.length > 1
          ? `${campaignName} successfully added to the Leads`
          : `${campaignName} successfully added to the Lead`
    );
    setAlertType("success");
    setAlertOpen(true);
  } catch (error: any) {
    setAlertMessage(
      error?.response?.data?.message || "Failed to assign leads"
    );
    setAlertType("error");
    setAlertOpen(true);
  }
};


  return (
    <div className="leadlist-wrapper add-lead-list-wrapper">
      {/* Breadcrumb Section */}
      <div style={{ display: !viewOpen ? "block" : "none" }} className="leadlist-block-container">
        <div>
          <AddLeadFilter
            isOpenFilter={isOpenFilter}
            setIsOpenFilter={setIsOpenFilter}
            selectedLeadsFilter={appliedFilterCount}
            selectedAllLeads={selectedAllLeads}
            setSelectedAllLeads={setSelectedAllLeads}
            selectedCreateLeads={selectedCreateLeads}
            setSelectedCreateLeads={setSelectedCreateLeads}
            selectedActions={selectedActions}
            setSelectedActions={setSelectedActions}
            onSearch={handleSearch}
            searchRef={searchRef}
            isResetSearch={isResetSearch}
            resetSearch={resetSearch}
            disableSelectedLeads={checkDisableOfActionScope()}
            setIsShowCreateLead={setIsShowCreateLead}
            isShowCreateLead={isShowCreateLead}
            disabled={disableMassActions}
            selectOpen={selectOpen}
            setSelectOpen={setSelectOpen}
            totalLeads={data?.length || 0}
            showImportModal={showImportModal}
            setShowImportModal={setShowImportModal}
            isShowCreateLeadSection={isShowCreateLeadSection}
            setIsShowCreateLeadSection={setIsShowCreateLeadSection}
            fetchLeads={() => {
              setIsResetSearch(!isResetSearch);
              setSearchText("");
              fetchLeads(currentPage);
            }}
            showNextButton={Object.values(selectedLeadsMap).flat().length > 0}
            setOpenStatusDialog={setOpenStatusDialog}
          />
        </div>
        {/* Table Section */}
        <div className="lead-list-table-filter">
          <div
            className="lead-list-table"
            style={isOpenFilter ? { width: "80%" } : {}}
          >
            <MUITable
              headers={headers}
              data={formattedData.map((item) => ({
                key: item.id,
                select: (
                  <Checkbox
                    checked={
                      selectedLeadsMap[currentPage]?.includes(item.id) || false
                    }
                    onClick={(event) => event.stopPropagation()}
                    onChange={() => handleCheckboxChange(item.id)}
                  />
                ),
                leadName: item.leadName,
                email: item.email,
                phone: item.phone,
                leadSource: item.leadSource,
                leadOwner: item.leadOwner,
                leadCreatedBy: item.leadCreatedBy,
                leadStatus: <LeadsStatus status={item.leadStatus} />,
              }))}
              onSort={handleSort}
              noResultsTxt={noResultText}
            />
          </div>
          <div
            style={{ display: isOpenFilter ? "block" : "none" }}
            className="lead-list-filter"
          >
            <LeadFilterOptions
              isOpenFilter={isOpenFilter}
              setIsOpenFilter={setIsOpenFilter}
              selectedLeadsFilter={selectedLeadsFilter}
              setSelectedLeadsFilters={setSelectedLeadsFilters}
              selectedLeadsFilterOptions={selectedLeadsFilterOptions}
              setAlertMessage={setAlertMessage}
              setAlertType={setAlertType}
              setAlertOpen={setAlertOpen}
              setSelectedLeadsFilterOptions={setSelectedLeadsFilterOptions}
              onApplyFilters={(filters: any) => {
                setCurrentPage(1);
                setActiveFilters(filters);
              }}
              activeFilters={activeFilters}
            />
          </div>
        </div>
        {totalRecords && totalRecords > 0 ? (
          <div
            className="leads-pagination-container"
            style={{
              pointerEvents: showImportModal ? "none" : "auto",
              opacity: showImportModal ? 0.5 : 1,
            }}
          >
            <PaginationComponent
              totalRecords={totalRecords}
              pageSize={pageSize}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
      <AddLead
  open={isShowCreateLead}
  onClose={() => setIsShowCreateLead(false)}
  title="Quick Create: New Lead"
  onSave={(leadId) => {
  setNewLeadId(leadId);
  setIsShowCreateLead(false);
  setCurrentPage(1);
  fetchLeads(1);
}}
/>

      <StatusDialog
  open={openStatusDialog}
  onClose={() => setOpenStatusDialog(false)}
  statusFilter={statusFilter}
  setStatusFilter={setStatusFilter}
  handleSaveStatus={handleAssignLeads}
/>

    </div>
  );
};

export default AddLeadList;
